import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './button-group.styl'

export default class ButtonGroup extends Component {
  static propTypes = {
    right: PropTypes.bool,
    center: PropTypes.bool,
    children: PropTypes.any.isRequired,
    paddedBottom: PropTypes.bool
  }

  render() {
    const { children, right, center, paddedBottom } = this.props
    const buttonAsideClass = right ? styles.right : ''
    const buttonCenterClass = center ? styles.center : ''
    const paddedBottomClass = paddedBottom ? styles.paddedBottom : ''
    let content = children

    if (children.length > 1) {
      content = children.filter(item => item).map((child, index) => (
        <div key={index} className={styles.button}>
          {child}
        </div>
      ))
    }

    return (
      <div className={`${styles.buttonGroup} ${paddedBottomClass}`}>
        <div className={`${buttonAsideClass} ${buttonCenterClass}`}>
          {content}
        </div>
      </div>
    )
  }
}
